export function assertNever(action: never): never {
  throw new Error('Unexpected code path due to unexpected object: ' + action);
}
